// Query-builder timestamps have no offset; the order API stores these in UTC.
export function parseOrderDate(value) {
    if (!value) return null;
    const text = String(value).trim();
    const timestamp = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(text)
        ? `${text.replace(' ', 'T')}Z` : text;
    const date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatOrderDate(value, {includeTime = false, timeZone} = {}) {
    const date = parseOrderDate(value);
    if (!date) return '';
    return new Intl.DateTimeFormat('en-IN', {
        day:'numeric', month:'short', year:'numeric',
        ...(includeTime ? {hour:'2-digit', minute:'2-digit', timeZoneName:'short'} : {}),
        ...(timeZone ? {timeZone} : {}),
    }).format(date);
}
